/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

export const GET_GREEN_SCORE_RESPONSE = {
	title: "Total CO2e Emissions: Scatter Plot",
	thresholdX: 2.3,
	thresholdY: 3.4,
	scatterPoints: [
		{
			name: "Application 1",
			value: [1.2, 2.8],
			unit: "KgCO2e",
			category: "Web Service",
			color: "#FF5733"
		},
		{
			name: "Application 2",
			value: [3.1, 1.7],
			unit: "KgCO2e",
			category: "Machine Learning",
			color: "#33FF57"
		},
		{
			name: "Application 3",
			value: [2.5, 3.9],
			unit: "KgCO2e",
			category: "Database",
			color: "#3357FF"
		},
		{
			name: "Application 4",
			value: [4.0, 2.5],
			unit: "KgCO2e",
			category: "Analytics",
			color: "#FF33A1"
		},
		{
			name: "Application 5",
			value: [1.8, 3.2],
			unit: "KgCO2e",
			category: "Batch Processing",
			color: "#FFC300"
		},
		{
			name: "Application 6",
			value: [3.3, 4.5],
			unit: "KgCO2e",
			category: "IoT",
			color: "#DAF7A6"
		}
	]
};

export const GET_WORST_10_EMISSIONS_RESPONSE = {
	title: "SCI score of the Apps",
	barSeries: [
		{
			name: "Environmental Impact",
			bars: [
				{
					name: "GCP Application",
					value: 85,
					unit: "kgCO2"
				},
				{
					name: "AWS German Cluster",
					value: 75,
					unit: "kgCO2"
				},
				{
					name: "Azure Spain Platform",
					value: 65,
					unit: "kgCO2"
				},
				{
					name: "Dummy eCommerce",
					value: 60,
					unit: "kgCO2"
				},
				{
					name: "Fatturazione",
					value: 52,
					unit: "kgCO2"
				},
				{
					name: "APP name max25digt",
					value: 40,
					unit: "kgCO2"
				},
				{
					name: "APP name max25digt",
					value: 35,
					unit: "kgCO2",
					tenantRegion: true
				},
				{
					name: "APP name max25digt",
					value: 30,
					unit: "kgCO2",
					tenantRegion: true
				},
				{
					name: "APP name max25digt",
					value: 25,
					unit: "kgCO2",
					tenantRegion: true
				}
			]
		}
	]
};
